import {Component, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {AuthService} from '../service/auth.service';
import {Router, ActivatedRoute} from '@angular/router';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    signin: FormGroup;
    singinformtouched: boolean = false;
    message: string;
    redirectURL: any;
    loading: boolean = true;   // controls initial spinner vs. form

    constructor(private singinfb: FormBuilder, private authservice: AuthService, private router: Router, private route: ActivatedRoute) {
    }

    ngOnInit() {
        let params = this.route.snapshot.queryParams;
        if (params['redirectURL']) {
            this.redirectURL = params['redirectURL'];
            console.log(this.redirectURL)
        }
        if (localStorage.getItem('auth-token')) {
            this.router.navigate(['/news'])
        }
        this.signin = this.singinfb.group({
            'email': ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
            'password': ['', [Validators.required]]
        })
        this.authservice.hideshowheader(false);

      this.loading = false;   // stop showing the loader once normal flow begins
    }

    userSignin(data) {
        this.singinformtouched = true;
        if (this.signin.valid) {
            this.authservice.signin(data).subscribe((res: any) => {
                if (res && res.mfa_required) {
                    this.authservice.pendingMfaToken = res.mfa_token;
                    this.router.navigate([res.setup_required ? '/mfa-setup' : '/mfa-verify']);
                    return;
                }
                if (res && res.status) {
                    this.authservice.completeLogin(res);
                    if (this.redirectURL) {
                        this.router.navigateByUrl('/refresh', { skipLocationChange: false }).then(() =>
                            this.router.navigateByUrl(this.redirectURL));
                        this.router.navigateByUrl(this.redirectURL)
                            .catch(() => this.router.navigate(['/news']));
                    } else {
                        this.router.navigate(['/news']);
                    }
                } else {
                    this.message = res.message;
                }
            });
        }
    }
}


export interface singininterface {
    status: boolean,
    message: string,
    token?: any,
    user_slug: any;
    tutor_ornot: any,

}



